import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

const TaxDiagnosticSummaryContext = React.createContext(undefined);

export const TaxDiagnosticSummaryProvider = ({
  children,
}) => {
  const [questionsSaving, setQuestionsSaving] = useState(new Set());

  const onSaveStarted = useCallback((val) => {
    const updatedQuestions = new Set([...questionsSaving]);
    updatedQuestions.add(val);
    setQuestionsSaving(updatedQuestions);
  }, []);

  const onSaveComplete = useCallback((val) => {
    const updatedQuestions = new Set([...questionsSaving]);
    updatedQuestions.delete(val);
    setQuestionsSaving(updatedQuestions);
  }, []);

  const memoizedValue = React.useMemo(() => {
    return {
      questionsSaving,
      onSaveComplete,
      onSaveStarted,
    };
  }, [
    questionsSaving,
    onSaveStarted,
    onSaveComplete,
  ]);

  return (
    <TaxDiagnosticSummaryContext.Provider value={memoizedValue}>
      {children}
    </TaxDiagnosticSummaryContext.Provider>
  );
};


export const useTaxDiagnosticSummaryContext = () => {
  const context = React.useContext(TaxDiagnosticSummaryContext);
  if (context === undefined) {
    throw new Error('useCommentLayoutContext must be used within a TaxDiagnosticSummaryContext');
  }
  return context;
};

TaxDiagnosticSummaryProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
